__turbopack_context__.v({
  "container": "tile-module-scss-module__EItXBa__container",
  "content": "tile-module-scss-module__EItXBa__content",
  "date": "tile-module-scss-module__EItXBa__date",
  "externalLink": "tile-module-scss-module__EItXBa__externalLink",
  "hovering": "tile-module-scss-module__EItXBa__hovering",
  "image": "tile-module-scss-module__EItXBa__image",
  "imageContainer": "tile-module-scss-module__EItXBa__imageContainer",
  "postInfo": "tile-module-scss-module__EItXBa__postInfo",
  "square": "tile-module-scss-module__EItXBa__square",
  "subtitle": "tile-module-scss-module__EItXBa__subtitle",
  "tall": "tile-module-scss-module__EItXBa__tall",
  "tile": "tile-module-scss-module__EItXBa__tile",
});
